/** @format */

import {styled} from '@mui/material/styles';
import {Box, Typography} from '@mui/material';

import SecondaryMediumButton from 'components/buttons/SecondaryMediumButton';

import {MAX_PROJECT_TEXT_WIDTH} from './constants';

export const Root = styled(Box)(({theme}) => ({
  '.MuiBackdrop-root .Modal-outerOuterContainerNew, .MuiBackdrop-root .Modal-innerContainerNew': {
    background: theme.palette.figma_gray_light_0?.main,
    maxWidth: 'unset',
  },

  '.MuiBackdrop-root .Modal-outerOuterContainerNew .Modal-headerNew': {
    padding: theme.spacing(6, 6, 8, 6),
  },

  '.MuiBackdrop-root .Modal-outerOuterContainerNew .Modal-header': {
    paddingBottom: theme.spacing(17),

    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1),
    },
  },

  '.MuiBackdrop-root .Modal-innerContainerNew .Modal-contentNew': {
    padding: theme.spacing(0, 6),
  },
}));

export const OtherReportButton = styled(SecondaryMediumButton)(({theme}) => ({
  background: theme.palette.figma_gray_light_1?.main,
  color: theme.palette.figma_gray_dark_1?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  padding: theme.spacing(0, 4),
  flexShrink: 0,
}));

export const InfoBox = styled(Box)(({theme}) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  marginBottom: theme.spacing(6),

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

interface ProjectAndDateProps {
  isColumn: boolean;
}

export const ProjectAndDate = styled(Box, {
  shouldForwardProp: prop => prop !== 'isColumn',
})<ProjectAndDateProps>(({theme, isColumn}) => ({
  display: 'flex',
  flexDirection: isColumn ? 'column' : 'row',
  gap: theme.spacing(isColumn ? 4 : 8),

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
}));

export const Project = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: 'max-content',

  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const StyledDate = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '170px',
  flexShrink: 0,
}));

export const TextHeading = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_1?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '18px',
}));

export const TextRegular = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_1?.main,
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '24px',
  overflowWrap: 'break-word',
  maxWidth: MAX_PROJECT_TEXT_WIDTH,
}));

export const FormatBox = styled(Box)(({theme}) => ({
  width: '668px',
  borderRadius: theme.spacing(2),
  display: 'flex',
  gap: theme.spacing(0.5),
  overflow: 'hidden',

  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    width: '100%',
  },
}));
